var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z",
    fill: "url(#paint0_linear_5537_5035)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.77V15.73C22 14.14 21.36 13.5 19.77 13.5H15.73C14.14 13.5 13.5 14.14 13.5 15.73V19.77C13.5 21.36 14.14 22 15.73 22H19.77C21.36 22 22 21.36 22 19.77Z",
    fill: "url(#paint1_linear_5537_5035)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z",
    fill: "url(#paint2_linear_5537_5035)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z",
    fill: "url(#paint3_linear_5537_5035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5537_5035",
    x1: 16.3559,
    y1: -0.0324856,
    x2: 23.873,
    y2: 5.64282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5537_5035",
    x1: 16.3559,
    y1: 11.4652,
    x2: 23.8794,
    y2: 17.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5537_5035",
    x1: 4.85589,
    y1: -0.0324856,
    x2: 12.373,
    y2: 5.64282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5537_5035",
    x1: 4.85589,
    y1: 11.4652,
    x2: 12.3794,
    y2: 17.1386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09EF65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16E2EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceActive);
export default __webpack_public_path__ + "static/media/service-active.090e355f37fc4cb90f4258b52bf231c2.svg";
export { ForwardRef as ReactComponent };